<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :height="600"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>

      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <el-row :span="24">
          <el-col :span="12">
            <div class="m-2">
              <batch-table
                :disabled="disabled"
                :packageDetailCode="row.purchasePackageDetailCode"
                :packageCode="row.purchasePackageCode"
              />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="m-2">
              <expense-table
                :disabled="disabled"
                :packageDetailCode="row.purchasePackageDetailCode"
                :packageCode="row.purchasePackageCode"
              />
            </div>
          </el-col>
        </el-row>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || 查看"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  params: { code: row.purchasePackageDetailCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            
            :content="$l('INDEX.btn_tips_edit') || 编辑"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              v-if="!disabled"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  params: { code: row.purchasePackageDetailCode },
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l("INDEX.table_label_no_data") || "暂无数据！" }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from "@/mixins/table-auto-height"
import tableColumns from "./table-columns"
import BatchTable from "./components/batch-table"
import ExpenseTable from "./components/expense-table"
export default {
  mixins: [TableAutoHeight],
  components: { BatchTable, ExpenseTable },
  props: {
    disabled: Boolean,
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => this.$emit("reload"),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
      tableHeight: 600,
    }
  },
  methods: {
    //批量删除前的验证
    getCheckboxRecords(type = "code") {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l("INDEX.tips_question_del_rows") || "请选择需要删除的数据！",
          type: "warning",
        })
        return
      }

      if (data.length > 20) {
        this.$message({
          showClose: true,
          message:
            this.$l("INDEX.tips_question_max_select_rows") ||
            "最多可选择20行！",
          type: "warning",
        })
        return
      }

      if (type === "code") {
        return data.map((row) => {
          return row.purchasePackageDetailCode
        })
      }
      return data
    },
  },
}
</script>
